import { useMemo } from 'react';
import { loadStripe, type Stripe } from '@stripe/stripe-js';

function getStripePublishableKey(): string | null {
  const meta = document.querySelector('meta[name="stripe-publishable-key"]');
  const value = meta?.getAttribute('content')?.trim();
  return value && value.length > 0 ? value : null;
}

export function requireStripePublishableKey(): string {
  const key = getStripePublishableKey();
  if (!key) {
    throw new Error('Stripe publishable key is missing. Set stripe-publishable-key meta tag.');
  }
  return key;
}

export function useStripePromise(): Promise<Stripe | null> {
  return useMemo(() => {
    const key = getStripePublishableKey();
    return key ? loadStripe(key) : Promise.resolve(null);
  }, []);
}
